import BillingInvoiceTemplatesAbstractEditorController from './abstract-editor-controller';

export default class BillingInvoiceTemplatesEditController extends BillingInvoiceTemplatesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this._loadInvoiceTemplate();
    }

    _loadInvoiceTemplate() {
        this._updateNavigation();
        this.api
            .get(`billing/invoices/templates/${this.stateParams.id}`)
            .then(({data}) => {
                this.model = {
                    ...data.data,
                    processing_costs_general_position_id: data.data.processing_costs_general_position_id ? data.data.processing_costs_general_position_id : '',
                    processing_costs_per_person_position_id: data.data.processing_costs_per_person_position_id ? data.data.processing_costs_per_person_position_id : '',
                    shipping_costs_position_id: data.data.shipping_costs_position_id ? data.data.shipping_costs_position_id : ''
                };
                this.loading = false;
                this._updateNavigation();
            })
    }

    doSave() {
        this.api
            .put(`billing/invoices/templates/${this.model.id}`, this.prepareModelForApi())
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }

    _updateNavigation() {
        this.navHelper.setTranslationsParamsForEntry(
            'settings.billing.invoice_templates.details',
            {
                name: this.loading ? this.translate.instant('general.verbs.loading_dot') : this.model.title
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/controllers/pages/edit-controller.js